/**
 * @copyright 2022 Nuance Communications Inc.
 * All Rights Reserved.
 */

/**
 * Navigate to a URL using window.location.assign.
 * Extracted to a module so it can be mocked in tests (window.location.assign
 * is non-configurable in newer jsdom versions).
 */
export const navigateToUrl = (url: string): void => {
    window.location.assign(url);
};
